import { TextFormat } from '@modusign/react-signing/types';
import i18n from 'i18next';
import { MouseEventHandler } from 'react';

import TextBaseFieldPlaceholder, {
  TextBaseFieldPlaceholderProps,
} from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/TextBaseFieldPlaceholder';

export interface TextFieldPlaceholderProps extends Omit<TextBaseFieldPlaceholderProps, 'value'> {
  format: TextFormat | null;
}

function formatText(format: TextFormat | null) {
  if (format?.type === 'PHONE_NUMBER') {
    return i18n.t('TextFieldPlaceholder-phoneNumber');
  }
  if (format?.type === 'BIZ_NUMBER') {
    return i18n.t('TextFieldPlaceholder-bizNumber');
  }
  if (format?.type === 'BANK_ACCOUNT_NUMBER') {
    return i18n.t('TextFieldPlaceholder-bankAccountNumber');
  }
  return i18n.t('TextFieldPlaceholder-text');
}

const defaultProps = {
  rootElementSize: null,
  onMouseDown(_event: MouseEventHandler<HTMLDivElement>) {},
};

function TextFieldPlaceholder({ format, ...props }: TextFieldPlaceholderProps) {
  return <TextBaseFieldPlaceholder {...props} value={formatText(format)} />;
}

TextFieldPlaceholder.defaultProps = defaultProps;

export default TextFieldPlaceholder;
